var _defs, _rect, _rect2, _path, _path2, _rect3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "body",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7AA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2050FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prong",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E9EEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bolt",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB020"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4,
    width: 5,
    height: 14,
    rx: 2.5,
    fill: "url(#prong)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 4,
    width: 5,
    height: 14,
    rx: 2.5,
    fill: "url(#prong)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18h36v10c0 10-7 17-18 17S14 38 14 28z",
    fill: "url(#body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21h30v4c0 2-1 3-3 3H20c-2 0-3-1-3-3z",
    fill: "#FFFFFF",
    opacity: 0.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44,
    width: 8,
    height: 10,
    rx: 2,
    fill: "#1A3FCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v4c0 2-2 3-4 3h-6",
    fill: "none",
    stroke: "#1A3FCC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22l-8 11h6l-3 9 9-12h-6z",
    fill: "url(#bolt)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.ae4eef6d9b91df28180e5755ff644b0c.svg";
export { ForwardRef as ReactComponent };